import { CognitoAuthProvider } from 'ra-auth-cognito'
import { CognitoUserPool } from 'amazon-cognito-identity-js'

import cognito from '../../../../cdk/bapp/lib/lambda-api/src/cognito.json'

const env = process.env['ENV'] as string
const { userPoolId: UserPoolId, clientId: ClientId } =
  cognito[env as keyof typeof cognito]
const userPool = new CognitoUserPool({
  UserPoolId,
  ClientId
})

export const cognitoAuthProvider = CognitoAuthProvider(userPool)
